<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between mb-4">
      <div>
        <div class="section-title">User Journey</div>
        <div class="section-subTitle my-2">Manage All your user Journeys</div>
      </div>
      <div>
        <b-button variant="default" to="add-user-journey" class="btn-blue">{{
          $t("add")
        }}</b-button>
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-end mb-3">
      <!-- <FilterByStatusDropdown /> -->
    </div>

    <div class="white-wrapper">
      <header class="journey-header">
        <div class="row">
          <div class="col-md-8 align-self-center">
            <ul>
              <li>
                <router-link
                  to
                  @click.native="onFetchUserJourney('All')"
                  :class="getSelectedStatus == 'All' ? 'active' : ''"
                  >All</router-link
                >
              </li>
              <!-- <li>
                <router-link to>Running</router-link>
              </li>
              <li>
                <router-link to>Stopped</router-link>
              </li>
              <li>
                <router-link to>Sunset</router-link>
              </li>-->
              <li>
                <router-link
                  to
                  @click.native="onFetchUserJourney('Draft')"
                  :class="getSelectedStatus == 'Draft' ? 'active' : ''"
                  >Drafts</router-link
                >
              </li>
            </ul>
          </div>
          <div class="col-md-4">
            <input
              type="search"
              @keyup="onSearchJoruney($event)"
              class="form-control form-control-sm"
              placeholder="Search by journey name"
            />
          </div>
        </div>
      </header>

    <!-- class="table journey-table" -->
      <table class="list-view-table mt-3">
        <thead>
          <tr>
            <th class="text-left">
              JOURNEY NAME
            </th>

            <th>
              STATUS
            </th>

            <th>
              START DATE
            </th>

            <!-- <td>
              <span>JOURNEY NAME</span>
            </td>

            <td>
              <span>ENTRIES</span>
            </td>

            <td>
              <span>EXITS</span>
            </td>-->

            <th>
              LAST UPDATED
            </th>
            <th class="text-right">
              LAST UPDATED
            </th>
          </tr>
        </thead>
        <tbody v-if="userJourneyList.length > 0">
          <!-- userJourneyList -->
          <tr
            v-for="(journey, journeyLoopKey) in userJourneyList"
            :key="journeyLoopKey"
          >
            <td>
              <div class="d-flex justify-content-between">
                <div>
                  <router-link to>{{ journey.user_journey_name }}</router-link>
                </div>
                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item
                    @click="
                      goToRoute(
                        '/marketing-automation/edit-user-journey',
                        journey
                      )
                    "
                  >
                    <span class="edit-pen mr-1"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="
                      goToRoute(
                        '/marketing-automation/view-user-journey',
                        journey
                      )
                    "
                  >
                    <span class="icon-eye mr-1"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>

                  <!-- <b-dropdown-item to="view-email-campaign">
                    <span class="icon-delete mr-1"></span>
                    Delete
                  </b-dropdown-item>-->
                </b-dropdown>
              </div>
            </td>
            <td>{{ journey.user_journey_status }}</td>
            <td>{{ journey.created_at | dateparse }}</td>
            <!-- <td>Entries</td>
            <td>0</td>
            <td>0</td>-->
            <td>{{ journey.updated_at | dateparse }}</td>
            <td>
              <div class="d-flex align-items-center justify-content-center">
                <!-- <b-form-checkbox
                  unchecked-value="N"
                  value="Y"
                  v-model="journey.user_journey_is_active"
                  name="check-button"
                  @change="OnSwitchHandler($event, journey)"
                  switch
                ></b-form-checkbox> -->
                <StatusDot
                  :status="
                    journey.user_journey_is_active === 'Y'
                      ? 'active'
                      : journey.user_journey_is_active === 'N' && 'inactive'
                  "
                />
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5">
              <!-- <div class="h6 my-3 text-center">{{ $t('NoRecords') }}</div> -->
              <NoRecords/>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <b-modal
      id="confirmation"
      title="Confirm ?"
      hide-footer
      no-close-on-backdrop
      @close="onCancelStatus"
    >
      <div class="text-center pb-1">
        <p class="fs-16 mb-2">
          {{
            `Are you sure you want to ${
              selectedJourney.user_journey_is_active == "N"
                ? "disable"
                : "Active"
            } this Journey?`
          }}
        </p>

        <button class="btn-outline-blue" @click.prevent.stop="onCancelStatus">
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-danger btn-danger-lg px-4 fs-14"
          @click.prevent.stop="updateStatus"
          v-if="selectedJourney.user_journey_is_active == 'N'"
        >
          Disable
        </button>
        <button
          class="btn btn-success btn-success-lg px-4 fs-14"
          @click.prevent.stop="updateStatus"
          v-else
        >
          Active
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords
  },
  data() {
    return {
      selectedJourney: ""
    };
  },
  computed: {
    ...mapGetters(["userJourneyList", "getSelectedStatus"])
  },
  mounted() {
    this.onFetchUserJourney("All");
  },
  methods: {
    ...mapActions([
      "onFetchUserJourney",
      "onSearchJoruney",
      "onUpdateUserJourney"
    ]),
    OnSwitchHandler(event, journey) {
      this.selectedJourney = journey;
      this.$bvModal.show("confirmation");
    },
    onCancelStatus() {
      this.$bvModal.hide("confirmation");
      this.selectedJourney = "";
      this.onFetchUserJourney("All");
    },
    updateStatus() {
      let payload = {
        user_journey_id: this.selectedJourney.user_journey_id,
        user_journey_is_active: this.selectedJourney.user_journey_is_active,
        statusUpdate: true
      };
      this.onUpdateUserJourney(payload);
    },
    goToRoute: function(path, { user_journey_id }) {
      this.$router.push({
        path: path,
        query: { user_journey_id }
      });
    }
  }
};
</script>

<style>
.journey-header {
  padding-bottom: 10px;
  border-bottom: 1px solid #d3d3d3;
}

.journey-header ul {
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
  display: inline-flex;
}

.journey-header ul li a {
  color: grey;
  display: table;
  position: relative;
  padding: 0 15px 0px 15px;
}

.journey-header ul li a.active {
  color: var(--blue);
  font-weight: bold;
}

.journey-header ul li a.active::after {
  left: 0;
  content: "";
  width: 100%;
  height: 3px;
  bottom: -16px;
  display: block;
  position: absolute;
  background-color: var(--blue);
}

.journey-header ul li a:hover {
  color: var(--blue);
}

.journey-header input[type="search"]::placeholder {
  font-size: 12px;
}

.journey-table {
  margin-top: 15px;
  /* overflow: hidden; */
  text-align: center;
  border-radius: 5px;
  background-color: #f8f9fa;
}

.journey-table thead {
  color: grey;
  font-size: 12px;
}

.journey-table thead td:first-child,
.journey-table tbody td:first-child {
  width: 30%;
  border-right: 1px solid #d3d3d3;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingAutomationContainer/UserJourneyComponents/userJourney.vue